export default __webpack_public_path__ + "static/media/logo.71c2a17e.svg";